import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import NewComplaintPage from './pages/NewComplaintPage';
import TrackComplaintPage from './pages/TrackComplaintPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import ScheduleReportPage from './pages/ScheduleReportPage';
import SitemapPage from './pages/SitemapPage';
import AccessibilityPage from './pages/AccessibilityPage';
import ForgotPassword from './pages/ForgotPassword';
import { AuthProvider } from './contexts/AuthContext';
import ResetPasswordModal from './components/ResetPasswordModal';
import { LocationProvider } from './contexts/LocationProvider';
import { getFullUrl } from './config/apiConfig';
//import VisitorCounter from './components/VisitorCounter';


function App() {
      useEffect(() => {
    // 1. Create the first script tag (External Library)
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-0XEKD8YR4Y";
    document.head.appendChild(script1);

    // 2. Create the second script tag (Initialization)
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-0XEKD8YR4Y');
    `;
    document.head.appendChild(script2);
  }, []);


useEffect(() => {
  const fetchLocation = async () => {
    try {
      const response = await fetch('https://geolocation-db.com/json/'); // Using a fallback provider
      
      if (!response.ok) return; // Exit if the request failed (429, 500, etc.)

      const data = await response.json();

      // ONLY proceed if we have valid coordinates, not an error object
      if (data && data.latitude && data.longitude) {
        await fetch(getFullUrl('/analytics/save-hit'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lat: data.latitude,
            lng: data.longitude,
            city: data.city || 'Unknown'
          }),
        });
      }
    } catch (error) {
      console.error("Gracefully caught tracking error:", error);
    }
  };

  fetchLocation();
}, []);
 


  return (
    <AuthProvider>
      <LocationProvider>
      <Router>
        <Layout style={{ fontFamily: "'Khand', sans-serif" }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/complaint/new" element={<NewComplaintPage />} />
            <Route path="/complaint/status" element={<TrackComplaintPage />} />
            <Route path="/complaint/login" element={<LoginPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
           <Route path="/reset-password-form" element={<ForgotPassword />} />


            {/* Protected Routes - Require Authentication */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reset-password"
              element={
                <ProtectedRoute>
                  <ResetPasswordModal />
                </ProtectedRoute>
              }
            />

            {/* Admin Only Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            
          </Routes>

          {/* <VisitorCounter /> */}
      {/* your routes/components */}
    
        </Layout>
      </Router>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
